/**
 * Admin Payment Request Form
 * Embedded within the Admin ChatPanel to send payment requests to students.
 * Adapted from DOUBTQ CHATBOT/admin/src/components/PaymentRequestForm.jsx
 */

import React, { useState } from 'react';
import { useChatAuth } from '../../hooks/ChatAuthContext';
import { getChatSocket } from '../../services/chatSocket';

const PaymentRequestForm = ({ orderId, onSuccess }) => {
    const { user } = useChatAuth();
    const socket = getChatSocket();

    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!amount) {
            setError('Please provide an amount');
            return;
        }

        if (isNaN(amount) || Number(amount) <= 0) {
            setError('Please provide a valid numeric amount greater than 0');
            return;
        }

        setLoading(true);

        try {
            // Emitting 'payment-request' specifically, instead of generic 'send-message'
            // This ensures backend sets status to 'pending' and properly saves paymentData
            socket.emit('payment-request', {
                orderId,
                senderId: user.id || 'admin',
                amount: Number(amount),
                paymentLink: '',
                currency: 'USD'
            });

            setAmount('');

            if (onSuccess) {
                onSuccess();
            }

        } catch (err) {
            console.error('Failed to send payment request:', err);
            setError('Failed to send payment request');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="chat-payment-form">
            <h4 className="chat-payment-form-title">💳 Request Payment</h4>

            <form onSubmit={handleSubmit}>
                {error && <div className="chat-payment-error">{error}</div>}

                <div style={{ marginBottom: '16px' }}>
                    <label>Amount ($)</label>
                    <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="e.g. 50"
                        min="1"
                        step="0.01"
                        required
                        style={{ width: '100%' }}
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading || !amount}
                    className="chat-btn-primary"
                    style={{ width: '100%' }}
                >
                    {loading ? 'Sending Request...' : 'Send Payment Request'}
                </button>
            </form>
        </div>
    );
};

export default PaymentRequestForm;
